import script from "./AudioStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./AudioStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./AudioStylePanel.vue?vue&type=style&index=0&id=d4e6bbec&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4e6bbec"]])

export default __exports__